import {Button, Input, Switch, Textarea, Typography} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../../style/datePicker.css"
import FileInput from "../../system/fileInput";
import {getAgentDisplayDetail, updateAgentDisplayDetail} from "../../../services/agent/agent";

export function AgentDisplayDetails({
                                      agent_Id,
                                      open,
                                      setOpen,
                                      setLastDataRefresh,
                                    }) {

  const [agentDisplayDetails, setAgentDisplayDetails] = useState({});
  const [agentId, setAgentId] = useState(agent_Id);
  const [rate, setRate] = useState(null);
  const [views, setViews] = useState(null);
  const [installment, setInstallment] = useState(false);
  const [visitCard, setVisitCard] = useState("");
  const [clip, setClip] = useState("");
  const [educationClip1, setEducationClip1] = useState("");
  const [educationClip2, setEducationClip2] = useState("");

  useEffect(() => {

    async function getData(agentId) {
      const result = await getAgentDisplayDetail(agentId);
      if (result.status === 200) {
        const {agent_display_detail} = result.data;
        setAgentDisplayDetails(agent_display_detail);
      }
    }

    if (agentId) {
      getData(agentId);
    }
  }, [agentId])

  useEffect(() => {
    setRate(agentDisplayDetails?.rate ?? 1);
    setViews(agentDisplayDetails?.views ?? 1);
    setInstallment(agentDisplayDetails?.installment ?? false);
    setVisitCard(agentDisplayDetails?.visit_card ?? "");
    setClip(agentDisplayDetails?.clip ?? "");
    setEducationClip1(agentDisplayDetails?.education_clip_1 ?? "");
    setEducationClip2(agentDisplayDetails?.education_clip_2 ?? "");
  }, [agentDisplayDetails])

  const save = async () => {
    const data = {
      agent_id: agentId,
      rate: rate,
      views: views,
      installment: installment,
      visit_card: visitCard,
      clip: clip,
      education_clip_1: educationClip1,
      education_clip_2: educationClip2,
    };
    let result;

    // TODO: change route
    result = await updateAgentDisplayDetail(data);

    if (result.status === 200) {
      setLastDataRefresh(Date.now())
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 gap-4 p-4 overflow-y-scroll md:grid-cols-2 xxl:grid-cols-3">

        <div className="w-full mt-2 mb-4">
          <Input variant="standard"
                 value={rate}
                 label={Dict('rate')}
                 placeholder={Dict('rate')}
                 type="number"
                 min="1"
                 step="0.1"
                 onChange={(e) => {
                   setRate(e.target.value)
                 }}
          />
        </div>

        <div className="w-full mt-2 mb-4">
          <Input variant="standard"
                 value={views}
                 label={Dict('views')}
                 placeholder={Dict('views')}
                 type="number"
                 min="1"
                 step="10"
                 onChange={(e) => {
                   setViews(e.target.value)
                 }}
          />
        </div>

        <div className="flex flex-row w-full mt-2 mb-4">
          <Switch
            label={
              <Typography color="blue-gray" className="font-medium">
                قسطی فعال / غیرفعال
              </Typography>
            }
            checked={installment}
            onChange={(e) => {
              setInstallment(e.target.checked)
            }}
            labelProps={{className: "mx-4"}}
          />
        </div>

        <div className="flex flex-row mb-4 md:w-1/2">
          <FileInput
            label={Dict('visit_card')}
            fileCode={visitCard}
            onChange={(e) => {
              setVisitCard(e.target.files[0]);
            }}/>
        </div>

        <div className="flex flex-row w-full mb-4 md:col-span-2">
          <Textarea
            variant="standard"
            value={clip}
            label={Dict('introduction_file')}
            onChange={(e) => {
              setClip(e.target.value)
            }}
          />
        </div>

        <div className="flex flex-row w-full mb-4 md:col-span-2">
          <Textarea
            variant="standard"
            value={educationClip1}
            label={'ویدیو آموزشی 1'}
            onChange={(e) => {
              setEducationClip1(e.target.value)
            }}
          />
        </div>

        <div className="flex flex-row w-full mb-4 md:col-span-2">
          <Textarea
            variant="standard"
            value={educationClip2}
            label={'ویدیو آموزشی 2'}
            onChange={(e) => {
              setEducationClip2(e.target.value)
            }}
          />
        </div>

      </div>
      <div className="text-left ml-4">
        <Button onClick={save}>
          ذخیره اطلاعات
        </Button>
      </div>
    </>
  );
}